module.exports = __webpack_public_path__ + "static/media/he.3a27a8fd.png";